import styled from "styled-components";

export const container = styled.div`
    & nav{
        width: min(26rem, 25vw);

        & ul{
            display: flex;
            flex-direction: column;

            .section-actual{
                    border-right: 2.5px solid #F58B1E;
                    color: #F58B1E;
                }

            & li{
                color: #B8B4CC;

                &:active, :hover{
                    border-right: 2.5px solid #F58B1E;
                    color: #F58B1E;
                }
                & button{
                    font-size: 2.5rem;
                    display: flex;
                    align-items: center;
                    color: inherit;
                    justify-content: center;
                    margin-left: 23%;
                    padding: 1.5rem 0;

                    & span{
                        margin-left: 2rem;
                        font: 600 1.5rem 'Poppins', arial ;
                    }

                    & img{
                        width: 2.5rem;
                    }
                }
            }
        }
    }

    @media (max-width: 576px){
        nav{
            width: 12vw;

            ul{
                li{
                    button{
                        font-size: 3rem;
                        span{
                            display: none;
                            
                        }
                    }
                }
            }
        }
    }

    @media (min-width: 577px) and (max-width: 766.98px){
        nav{
            ul{
                li{
                    button{
                        margin-left: 12%;
                        font-size: 2.25rem;

                        span{
                            font-size: 1.25rem;
                        }
                    }
                }
            }
        }
    }

    @media (min-width: 767.98px) and (max-width: 999px){
        nav{
            ul{
                li{
                    button{
                        margin-left: 17%;
                        font-size: 2.25rem;
                        
                        span{
                            
                        }
                    }
                }
            }
        }
    }

    
`
